import { Pipe, PipeTransform } from '@angular/core';

import {
  POLICY_RENEWAL_STATUS,
  PolicyRenewalStatus,
} from '@lockton-apps/shared/interfaces';

@Pipe({
  name: 'policyStatusIcon',
  standalone: true,
})
export class PolicyStatusIconPipe implements PipeTransform {
  metaMap = new Map<PolicyRenewalStatus, string>([
    [POLICY_RENEWAL_STATUS.Active, 'tick'],
    [POLICY_RENEWAL_STATUS.Expired, 'exclaim'],
    [POLICY_RENEWAL_STATUS.RenewalImminent, 'expire_pending'],
    [POLICY_RENEWAL_STATUS.RenewalUpcoming, 'expire_pending'],
  ]);

  transform(value: PolicyRenewalStatus): string {
    return this.metaMap.get(value) || 'unknown';
  }
}
